import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { AdminRole } from "../types/auth";




interface Props {
  role: AdminRole
}

const RequireRole: React.FC<Props> = ({ children, role }) => {
  const user = useSelector((state: RootState) => state.auth.user);

  if (!user?.roles.includes(role) && !user?.roles.includes(AdminRole.root)) {
    return null;
  }


  return (
    <React.Fragment>
      {children}
    </React.Fragment>
  );
};

export default RequireRole;